import { FREE } from 'self-service-api/constants/ProductLevels';
import { useAppSelector } from '../reducers';
import { isAppAuthSelector } from '../selectors/AuthSelectors';
import { hasPricingAndPurchasingSucceededSelector } from '../selectors/LoadingStateSelectors';
import { highestProductLevelFromProductInventorySelector } from '../selectors/ProductInventorySelectors';
export const useAddOnsPage = () => {
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const hasPricingAndPurchasingSucceeded = useAppSelector(hasPricingAndPurchasingSucceededSelector);
  const isFreePortal = useAppSelector(state => {
    if (!hasPricingAndPurchasingSucceeded) return false;
    return highestProductLevelFromProductInventorySelector(state) === FREE;
  });
  const showAddonsPage = hasPricingAndPurchasingSucceeded && isAppAuth && !isFreePortal;
  return {
    showAddonsPage
  };
};